import { createAction } from '@reduxjs/toolkit';

export const bannerUpdateId = createAction('banner/updateId');
export const bannerUpdateUID = createAction('banner/updateUid');
export const bannerUpdateSID = createAction('banner/updateSid');
export const bannerUpdateIsAdded = createAction('banner/updateIsAdded');
export const bannerUpdateIsActive = createAction('banner/updateIsActive');

export const bannerStore = createAction('banner/store');
export const bannerClear = createAction('banner/clear');

export const bannerUpdateRequest = createAction('banner/updateRequest');
export const bannerUpdateError = createAction('banner/updateError');
export const bannerUpdateStore = createAction('banner/updateStore');

export const bannerUpdateWidthView = createAction('banner/updateWidthView ');
export const bannerUpdateHeightView = createAction('banner/updateHeightView');
export const bannerUpdateHeight = createAction('banner/updateHeight');
export const bannerUpdateBannerWidth = createAction('banner/updateBannerWidth');

export const bannerUpdateDarkness = createAction('banner/updateDarkness');
export const bannerUpdateIsText = createAction('banner/updateIsText');
export const bannerUpdateText = createAction('banner/updateText');
export const bannerUpdateTextColor = createAction('banner/updateTextColor');
export const bannerUpdateDescription = createAction('banner/updateDescription');
export const bannerUpdateActionType = createAction('banner/updateActionType');

export const bannerUpdateCTASite = createAction('banner/updateCTASite');
export const bannerUpdateCTASiteText = createAction('banner/updateCTASiteText');
export const bannerUpdateCTABackgroundColor = createAction('banner/updateCTABackgroundColor');
export const bannerUpdateCTATextColor = createAction('banner/updateCTATextColor');
export const bannerUpdateCTAIsBorder = createAction('banner/updateCTAIsBorder');
export const bannerUpdateCTAOpacity = createAction('banner/updateCTAOpacity');
export const bannerUpdateCTALinkId = createAction('banner/updateCTALinkId');
export const bannerUpdateCTABlockId = createAction('banner/updateCTABlockId');
export const bannerUpdateCTAShadowColor = createAction('banner/updateCTAShadowColor');
export const bannerUpdateCTAShadow = createAction('banner/updateCTAShadow');
export const bannerUpdateCTAShape = createAction('banner/updateCTAShape');
export const bannerUpdateCTABorderColor = createAction('banner/updateCTABorderColor');
export const bannerUpdateCTABorder = createAction('banner/updateCTABorder');

export const bannerUpdateMediaHeader = createAction('banner/updateMediaHeader');
export const bannerUpdateHeroMedia = createAction('banner/updateHeroMedia');

export const bannerUpdateProductProvider = createAction('banner/updateProductProvider');
export const bannerUpdateProductSelect = createAction('banner/updateProductSelect');
export const bannerUpdateProductId = createAction('banner/updateProductId');

export const bannerUpdateHeadingTitle = createAction('banner/updateHeadingTitle');
export const bannerUpdateHeadingDescription = createAction('banner/updateHeadingDescription');
export const bannerUpdateHeadingTextAlign = createAction('banner/updateHeadingTextAlign');
export const bannerUpdateHeadingImage = createAction('banner/updateHeadingImage');
export const bannerUpdateHeadingDivider = createAction('banner/updateHeadingDivider');

export const bannerUpdateSectionIsBackground = createAction('banner/updateSectionIsBackground');
export const bannerUpdateSectionTextColor = createAction('banner/updateSectionTextColor');
export const bannerUpdateSectionBackgroundColor = createAction('banner/updateSectionBackgroundColor');
export const bannerUpdateSectionOpacity = createAction('banner/updateSectionOpacity');
export const bannerUpdateSectionIsFullWidth = createAction('banner/updateSectionIsFullWidth');
export const bannerUpdateSectionShadow = createAction('banner/updateSectionShadow');
export const bannerUpdateSectionShadowColor = createAction('banner/updateSectionShadowColor');
export const bannerUpdateSectionPadding = createAction('banner/updateSectionPadding');
export const bannerUpdateSectionMargin = createAction('banner/updateSectionMargin');
export const bannerUpdateSectionBackgroundType = createAction('banner/updateSectionBackgroundType');
export const bannerUpdateSectionBackgroundImage = createAction('banner/updateSectionBackgroundImage');
export const bannerUpdateSectionGradientColor1 = createAction('banner/updateSectionGradientColor1');
export const bannerUpdateSectionGradientColor2 = createAction('banner/updateSectionGradientColor2');
export const bannerUpdateSectionGradientDirection = createAction('banner/updateSectionGradientDirection');
export const bannerUpdateSectionGradientOffset = createAction('banner/updateSectionGradientOffset');
export const bannerUpdateSectionBorder = createAction('banner/updateSectionBorder');
export const bannerUpdateSectionBorderColor = createAction('banner/updateSectionBorderColor');
export const bannerUpdateSectionShadowBorderColor = createAction('banner/updateSectionShadowBorderColor');
export const bannerUpdateSectionShape = createAction('banner/updateSectionShape');
